import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Testimonials } from '../components/sections/Testimonials';
import { PainPoints } from '../components/sections/PainPoints';
import { Audience } from '../components/sections/Audience';
import { SystemOverview } from '../components/sections/SystemOverview';
import { TomosContent } from '../components/sections/TomosContent';
import { Bonos } from '../components/sections/Bonos';
import { ComparisonTable } from '../components/sections/ComparisonTable';
import { PricingSection } from '../components/sections/PricingSection';
import { ProElite } from '../components/sections/ProElite';
import { Guarantee } from '../components/sections/Guarantee';
import { FAQ } from '../components/sections/FAQ';
import { Footer } from '../components/sections/Footer';
import { PurchaseNotification } from '../components/ui/PurchaseNotification';
export function SalesPage() {
  return <div className="min-h-screen bg-brand-bg font-sans text-brand-dark selection:bg-brand-accent selection:text-brand-dark" data-id="element-340">
      <Hero data-id="element-341" />
      <Testimonials data-id="element-342" />
      <PainPoints data-id="element-343" />
      <Audience data-id="element-344" />
      <SystemOverview data-id="element-345" />
      <TomosContent data-id="element-346" />
      <Bonos data-id="element-347" />
      <ComparisonTable data-id="element-348" />
      <PricingSection id="pricing" data-id="element-349" />
      <ProElite data-id="element-350" />
      <Guarantee data-id="element-351" />
      <FAQ data-id="element-352" />
      <PricingSection id="pricing-final" isFinal={true} data-id="element-353" />
      <Footer data-id="element-354" />
      <PurchaseNotification data-id="element-355" />
    </div>;
}